import axios from 'axios'

/**
 * Traduce un contenido HTML usando la API de OpenAI.
 * Mantiene las etiquetas, clases e IDs, traduciendo solo el texto dentro de las etiquetas.
 *
 * @param {string} apiOpenAiUrl - URL base de la API de OpenAI (https://api.openai.com/v1/chat/completions).
 * @param {string} apiOpenAiKey - Clave de API de OpenAI.
 * @param {string} htmlToTranslate - HTML que deseas traducir.
 * @param {string} sourceLang - Idioma de origen (ejemplo: "es_es").
 * @param {string} targetLang - Idioma de destino (ejemplo: "ca_es").
 * @returns {Promise<string>} - Promesa que devuelve el HTML traducido.
 */
const translateHTML = (apiOpenAiUrl, apiOpenAiKey, htmlToTranslate, sourceLang, targetLang) =>
  new Promise((resolve, reject) => {
    try {
      // Configurar el prompt para procesar HTML
      const prompt = `
Traduce del idioma '${sourceLang}' al idioma '${targetLang}' sin comillas:
${htmlToTranslate}
      `.trim()

      const data = {
        model: 'gpt-3.5-turbo', // Puedes usar "gpt-4" si tienes acceso
        messages: [
          { role: 'system', content: 'Eres un traductor experto.' },
          { role: 'user', content: prompt }
        ],
        max_tokens: 4096, // Ajustar según el tamaño esperado del HTML
        temperature: 0.2 // Baja temperatura para resultados más consistentes
      }

      // Llamada a la API de OpenAI
      resolve(
        axios({
          method: 'POST',
          url: apiOpenAiUrl,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apiOpenAiKey}`
          },
          data
        })
          .then((response) => {
            const translatedHTML = response.data.choices[0].message.content.trim()
            return translatedHTML
          })
          .catch((err) => {
            reject(new Error(`Error al llamar a la API de OpenAI: ${err.message}`))
          })
      )
    } catch (err) {
      reject(new Error(`Error en el método translateHTML: ${err.message}`))
    }
  })

export default translateHTML
